<div class="main-content" id="main-content">
  <section id="breadcrumbs">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="br-breadcrumb">
            <ul class="crumb-list">
              <li class="crumb home">
                <a class="br-button circle" [routerLink]="['/']">
                  <span class="sr-only">Página inicial</span>
                  <i class="fas fa-home"></i>
                </a>
              </li>
              <li class="crumb" data-active="active">
                <i class="icon fas fa-chevron-right"></i>
                <span>Tabela de Convergência</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="page">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div id="page-header">
            <div id="page-title" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h2>{{ 'Tabela de Convergência' }}</h2>
                <p>
                  A Tabela de Convergência é uma lista que visa estabelecer a
                  relação entre as denominações de cursos superiores de
                  tecnologia que já foram adotadas por algumas instituições de
                  ensino e as denominações adotadas pelo presente Catálogo
                  Nacional de Cursos Superiores de Tecnologia, a fim de que as
                  denominações convergentes sejam adaptadas às denominações
                  constantes desse Catálogo, no caso de os cursos estarem em
                  funcionamento. A Tabela de Convergência serve, também, de
                  parâmetro para aqueles estudantes que concluíram seus cursos
                  antes das atualizações realizadas no Catálogo, indicando com
                  qual curso do Catálogo a sua formação estaria mais próxima.
                  Destaca-se que a relação entre os cursos não é direta, pois
                  uma mesma denominação pode apontar para diferentes cursos. Por
                  exemplo: o curso de Web Design tanto pode convergir para o
                  curso de Design Gráfico, como para Produção Multimídia, ou
                  ainda, para Sistemas para Internet; por isso é preciso uma
                  análise detalhada do curso para a decisão quanto à
                  convergência mais apropriada. Ressalta-se que a atual Tabela
                  contém as convergências identificadas pela edição atual (4ª
                  edição) e pelas edições anteriores dos Catálogos, a saber: de
                  2006, de 2010 e de 2016 (1ª, 2ª e 3ª edições).
                </p>
              </div>
            </div>

            <app-barra-busca
              [componenteRef]="componenteRef"
              (inputEvent)="recebeuInput($event)"
              [filtros]="false"
              [labelInput]="labelInput"
            >
            </app-barra-busca>

            <div id="page-data-share" class="row" *ngIf="!msgSemCurso">
              <div
                id="page-data"
                class="col-xs-12 col-sm-8 col-md-8 col-lg-8"
              ></div>
              <div
                id="page-share"
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
              >
                <span>Gerar:</span>
                <div class="share-buttons">
                  <a
                    class="br-button tertiary circle mr-3"
                    (click)="downloadPdfCursosConvergentes()"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </a>
                  <a
                    class="br-button tertiary circle mr-3"
                    (click)="downloadCsvCursosConvergentes()"
                  >
                    <i class="fas fa-file-csv"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div id="page-content">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <table class="convergence" *ngFor="let curso of pagedItems">
                  <thead>
                    <tr>
                      <th
                        class="text-center axle"
                        colspan="2"
                        [innerHTML]="
                          curso.eixoNome | highlight : stringBusca | uppercase
                        "
                      ></th>
                    </tr>
                    <tr>
                      <th class="text-center">
                        {{ 'Denominação do Curso' | uppercase }}
                      </th>
                      <th class="text-center border-left">
                        {{ 'Convergências' | uppercase }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="area" rowspan="100">
                        <strong
                          [innerHTML]="
                            curso.nome | highlight : stringBusca | uppercase
                          "
                        ></strong>
                      </td>
                    </tr>
                    <ng-container
                      *ngIf="
                        curso.cursosMudaramNomeCncst &&
                        curso.cursosMudaramNomeCncst.length > 0
                      "
                    >
                      <ng-container
                        *ngFor="
                          let cursoMudouNome of curso.cursosMudaramNomeCncst
                        "
                      >
                        <tr>
                          <td
                            class="border-left"
                            [innerHTML]="
                              cursoMudouNome.nome
                                | highlight : stringBusca
                                | uppercase
                            "
                          ></td>
                          <ng-container
                            *ngIf="
                              curso.cursosMudaramNomeCncst &&
                              curso.cursosMudaramNomeCncst.length < 1
                            "
                          >
                            <td class="border-left">Não Houve alteração</td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <ng-container *ngIf="totalResultados > 0">
    <app-paginacao
      [paginaAtual]="paginaAtual"
      [totalPaginas]="totalPaginas"
      (mudouPagina)="onPaginaSelecionada($event)"
    ></app-paginacao>
  </ng-container>
</div>
